import { Spinner } from 'components/UI';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { Table } from 'components/UI/V3/Table/Table';
import React from 'react';
import { formatCurrency, formatPercentage, VelocityData } from '../data/mockData';
import styles from './VelocityCohortTable.module.scss';

interface VelocityCohortTableProps {
    data: VelocityData;
    loading: boolean;
}

export const VelocityCohortTable: React.FC<VelocityCohortTableProps> = props => {
    const { rows, totals } = props.data;

    return (
        <Table firstColumnFixed>
            <TableHeader>
                <TableHeaderCell>Month</TableHeaderCell>
                <TableHeaderCell>New Leads</TableHeaderCell>
                <TableHeaderCell>New Clients</TableHeaderCell>
                <TableHeaderCell>Conv. Rate</TableHeaderCell>
                <TableHeaderCell>Median Days to Book</TableHeaderCell>
                <TableHeaderCell>First Visit Revenue</TableHeaderCell>
                <TableHeaderCell>90-Day Revenue</TableHeaderCell>
                <TableHeaderCell>Lost Clients</TableHeaderCell>
            </TableHeader>
            <TableBody>
                {props.loading && (
                    <tr>
                        <td
                            colSpan={8}
                            className={styles.loadingCell}
                        >
                            <Spinner />
                        </td>
                    </tr>
                )}
                {!props.loading && (
                    <>
                        {rows.map(row => (
                            <TableRow key={row.month}>
                                <TableCell>{row.month}</TableCell>
                                <TableCell>{row.leads}</TableCell>
                                <TableCell>{row.newClients}</TableCell>
                                <TableCell>{formatPercentage(row.convRate)}</TableCell>
                                <TableCell>{`${row.medianDaysToBook} days`}</TableCell>
                                <TableCell>{formatCurrency(row.revenueFirst)}</TableCell>
                                <TableCell>{formatCurrency(row.revenue90d)}</TableCell>
                                <TableCell className={styles.lostCell}>{row.lostClients}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow className={styles.totalsRow}>
                            <TableCell>2026 Total</TableCell>
                            <TableCell>{totals.leads}</TableCell>
                            <TableCell>{totals.newClients}</TableCell>
                            <TableCell>{formatPercentage(totals.convRate)}</TableCell>
                            <TableCell>{`${totals.medianDaysToBook} days`}</TableCell>
                            <TableCell>{formatCurrency(totals.revenueFirst)}</TableCell>
                            <TableCell>{formatCurrency(totals.revenue90d)}</TableCell>
                            <TableCell className={styles.lostCell}>{totals.lostClients}</TableCell>
                        </TableRow>
                    </>
                )}
            </TableBody>
        </Table>
    );
};

export default VelocityCohortTable;
